export default __webpack_public_path__ + "source-sans-pro-v11-latin-regular-74ddb2b07a7f05bded6da1fb93301a05.bundle.woff";